import React from "react";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import api from "../../utils/api";
import { decode } from "html-entities";
import DOMPurify from "dompurify";
import { Button } from "@material-tailwind/react";
import { ChevronLeftIcon } from "@heroicons/react/20/solid";
import CreatePropertyForm from "../../components/Property/CreatePropertyForm";

export function CreateProperty() {
  const navigate = useNavigate();

  const handlePrev = () => {
    navigate("/properties");
  };

  const cleanHtml = (html) => {
    return DOMPurify.sanitize(decode(html));
  };

  return (
    <div className="flex flex-col items-center justify-center w-full h-full p-2 pb-4 lg:pb-10 lg:p-16 gap-y-8">
      <Button
        variant="filled"
        color="orange"
        size="sm"
        className="self-start rounded-2xl my-2 py-1 px-2 text-bg !text-button1"
        onClick={handlePrev}
      >
        <ChevronLeftIcon className="size-6" />
      </Button>
      <CreatePropertyForm />
    </div>
  );
}

export default CreateProperty;
